import axios from 'axios'
import { getHeader, manufactureUrl } from './../config'

const state = {
  manufactureTypeList: [],
  manufactureMaterialCategoryList: [],
  manufactureExpenseTypeList: [],
  manufacture: {
    id: null,
    manufacture_no: null,
    materials: [{
      id: null,
      manufacture_no: null,
      price: '0',
      total_cogs: '0'
    }],
    mproducts: []
  }
}

const mutations = {
  SET_MANUFACTURE_TYPE_LIST (state, obj) {
    state.manufactureTypeList = obj
  },
  SET_MANUFACTURE_MATERIAL_CATEGORY_LIST (state, obj) {
    state.manufactureMaterialCategoryList = obj
  },
  SET_MANUFACTURE_EXPENSE_TYPE_LIST (state, obj) {
    state.manufactureExpenseTypeList = obj
  },
  SET_MANUFACTURE_BY_NO (state, obj) {
    state.manufacture = obj
  }
}

const actions = {
  getManufactureByNo: ({ commit }, payload) => {
    // { manufacture_no: 'xxxxxxxx' }
    axios.post(manufactureUrl + '/get-manufacture-no', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_MANUFACTURE_BY_NO', response.data.data)
      })
  },
  getManufactureTypeList: ({ commit }) => {
    axios.get(manufactureUrl + '/type', { headers: getHeader() })
      .then(response => {
        commit('SET_MANUFACTURE_TYPE_LIST', response.data.data)
      })
  },
  getManufactureMaterialCategoryList: ({ commit }) => {
    axios.get(manufactureUrl + '/material/category', { headers: getHeader() })
      .then(response => {
        commit('SET_MANUFACTURE_MATERIAL_CATEGORY_LIST', response.data.data)
      })
  },
  getManufactureExpenseTypeList: ({ commit }) => {
    axios.get(manufactureUrl + '/expense/type', { headers: getHeader() })
      .then(response => {
        commit('SET_MANUFACTURE_EXPENSE_TYPE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
